import axios from 'axios'

import { getCookie } from 'utils/cookie'

import store from 'store'

const defaultToken = process.env.NEXT_PUBLIC_TOKEN_PUBLIC

export const getHeaders = () => {
  const token = getCookie('accessToken') || defaultToken

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    }
  }

  return {}
}

export const defaultParams = {
  isActive: true,
  isDeleted: false,
}

const joinUrl = (base, path) => {
  const normalizedBase = (base || '').replace(/\/+$/, '')
  const normalizedPath = (path || '').replace(/^\/+/, '')

  if (!normalizedPath) {
    return normalizedBase
  }

  return `${normalizedBase}/${normalizedPath}`
}

const resolveServiceBaseUrl = fallbackBaseUrl => {
  // Use internal base only when executing on Next.js server runtime.
  if (typeof window !== 'undefined') {
    return fallbackBaseUrl
  }

  const internalBaseUrl = process.env.API_INTERNAL_BASE_URL

  if (!internalBaseUrl) {
    return fallbackBaseUrl
  }

  if (!fallbackBaseUrl) {
    return internalBaseUrl
  }

  try {
    const fallbackPath = new URL(fallbackBaseUrl).pathname
    return joinUrl(internalBaseUrl, fallbackPath)
  } catch (error) {
    return fallbackBaseUrl
  }
}

export const documentService = axios.create({
  baseURL: resolveServiceBaseUrl(process.env.NEXT_PUBLIC_DOCUMENT_API),
  // headers: getHeaders(),
})

export const masterDataService = axios.create({
  baseURL: resolveServiceBaseUrl(process.env.NEXT_PUBLIC_MASTER_DATA_API),
  // headers: getHeaders(),
})

export const authenService = axios.create({
  baseURL: resolveServiceBaseUrl(process.env.NEXT_PUBLIC_AUTHENTICATION_API),
  // headers: getHeaders(),
})

export const setAuthorizationToAllService = token => {
  masterDataService.defaults.headers.common.Authorization = `Bearer ${token}`
  documentService.defaults.headers.common.Authorization = `Bearer ${token}`
  authenService.defaults.headers.common.Authorization = `Bearer ${token}`
}

const services = [documentService, masterDataService, authenService]

services.forEach(service => {
  service.interceptors.request.use(config => {
    const token = store.getState().auth.token
    config.headers.Authorization = `Bearer ${token}`
    return config
  })
})
